<div class="row" *ngIf="!IsViewOrder">
    <div class="col-md-3">
        <mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden"
            *ngIf="GroupCategoryWithProduct.length>0">
            <div *ngIf="isTabs;then tabs else sidenav"></div>

            <ng-template #tabs>
                <mat-card-header class="mat-mdc-card-header bg-primary p-10 m-b-15">
                    <input class="inputTxt" placeholder="{{ 'search' | translate }}" maxlength="100" #searchVal
                        (change)='checkSearchVal(searchVal.value)' (keyup)="checkSearchVal(searchVal.value)"
                        (keyup.enter)="checkSearchVal(searchVal.value)" />
                    <i-tabler name="search" class="icon-20 d-flex clickIcon m-l-6 m-t-6"></i-tabler>
                </mat-card-header>

                <mat-tab-group (selectedTabChange)="tabClick($event)">
                    <mat-tab *ngFor="let parentCategory of GroupCategoryWithProduct;"
                        label="{{parentCategory.parentCategory}}">
                        <div class="col-md-12">
                            <app-slicemenu [DataList]="parentCategory.listCategory??[]"
                                           [selected]="selectedCategory" [columnName]="'categoryName'"
                                           (newItemEvent)="ShowProducts($event)"></app-slicemenu>
                        </div>
                    </mat-tab>
                </mat-tab-group>
            </ng-template>

            <ng-template #sidenav>
                <mat-sidenav-container class="mainWrapper">
                    <mat-sidenav #sidenav mode="side" opened="true">
                        <div class="row bg-primary p-10 m-b-15">
                            <div class="col-md-10">
                                <input class="inputTxt" placeholder="{{ 'search' | translate }}" maxlength="100" />
                            </div>
                            <div class="col-md-2"> <i-tabler name="search"
                                    class="icon-20 d-flex clickIcon m-l-6 m-t-6"></i-tabler>
                            </div>
                        </div>
                        <ng-scrollbar class="position-relative mini-scroll" style="height: calc(100vh - 230px)">
                            <mat-nav-list class="sidebar-list">
                                @for(item of GroupCategoryWithProduct; track item) {
                                <app-order-nav-item [item]="item"
                                    (newItemEvent)="GetProducts($event)"></app-order-nav-item>
                                }
                            </mat-nav-list>
                        </ng-scrollbar>
                    </mat-sidenav>
                </mat-sidenav-container>
            </ng-template>
        </mat-card>
    </div>

    <div class="col-md-9" *ngIf="showProductsList">
        <div *ngIf="productsList?.length==0;then NoProducts else Products"></div>
        <ng-template #NoProducts>
            <div class="col-md-12">
                <p> {{ 'NoDataFound' | translate}}</p>
            </div>
        </ng-template>

        <ng-template #Products>
            <div class="row">
                <div class="col-md-3 ValidationErrors" *ngIf="ValidationErrors">
                    {{ValidationErrors}}
                </div>
                <div class="col-md-9 divViewOrder">
                    <a (click)="ViewOrder()" class="btnViewOrder">
                        {{ 'ViewOrder' | translate}}
                    </a>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6" *ngFor="let product of productsList">
                    <mat-card class="mat-mdc-card mdc-card cardWithShadow">
                        <mat-card-header class="mat-mdc-card-header bg-primary p-10 m-b-15">
                            <div class="d-flex divIcons">
                                <i-tabler name="eye" class="icon-20 d-flex clickIcon"
                                    (click)="openDialog(product)"></i-tabler>
                            </div>
                        </mat-card-header>
                        <mat-card-content class="mat-mdc-card-content text-center">
                            <div class="row" [ngClass]="{active:ProductAddedDetailsId.includes(product?.id!)}">
                                <div class="col-md-2">
                                    <img alt="{{product.productName}}" width="80" height="80"
                                        src="{{product.imgURL | adjust_image_path}}">
                                </div>
                                <div class="col-md-10">
                                    <div class="data">
                                        <span class="productname"> {{product.name}}
                                            ({{product.colorName}})
                                        </span>
                                    </div>
                                    <div class="data">
                                        <span class="span-price">
                                            {{CalcPrice(product.pricePerOne,product.descount)}}
                                            {{ 'EGP' | translate }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>
            </div>
        </ng-template>
    </div>
</div>

<div *ngIf="IsViewOrder">
    <app-view-order [OrderProductsInfo]="OrderProductsInfo" (IsIsViewOrder)="CheckIsViewOrder($event)">
    </app-view-order>
</div>
